import React from 'react';
import { useSelector } from 'react-redux';
import {
  Form,
  Col,
  Modal,
  Typography,
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/ext-language_tools';
// import 'ace-builds/webpack-resolver';
import FormSubmitControls from 'components/FormSubmitControls';
import values from './values';
import schemas from './schemas';

const { Text } = Typography;

const Editor = ({
  form,
  formItemName,
  formItemLabel,
  rules,
  descuento,
  actualizacion,
  recargo,
  cargo,
  variables,
  disabled,
}) => {
  const [visible, setVisible] = React.useState(false);
  const tiposDeDato = useSelector(({ catalogs }) => catalogs.tiposDeDato);
  const obj = {
    descuento,
    actualizacion,
    recargo,
    cargo,
  };
  const valuesKey = Object.entries(obj).find((e) => e[1])?.shift();
  const onLoad = (editor) => {
    const mode = editor.getSession().getMode();

    mode.getCompletions = () => {
      const completions = [];
      if (variables?.length) {
        const mapped = variables.map((e) => ({
          ...e,
          meta: tiposDeDato.find((i) => i.id === e.tipo_de_variable)?.descripcion,
        }));
        mapped.forEach((e) => {
          completions.push({
            value: e.nombre,
            meta: e.meta,
            snippet: e.nombre,
            caption: e.nombre || '',
          });
        });
      }
      schemas.forEach((e) => {
        completions.push({
          value: e.name,
          meta: e.type,
          snippet: e.name,
          caption: e.name || '',
        });
      });

      return completions;
    };

    editor.getSession().setMode(mode);
  };

  return (
    <Col span={24}>
      <Form.Item
        name={formItemName}
        rules={rules}
        label={formItemLabel}
        tooltip={!disabled ? {
          icon: <QuestionCircleOutlined onClick={() => setVisible(true)} />,
          title: 'Ver instrucciones',
        } : null}
      >
        <AceEditor
          style={{
            height: 250,
            width: '100%',
          }}
          placeholder=""
          mode="python"
          theme="github"
          name="editor"
          onChange={(formula) => {
            form.setFieldsValue({ formula });
          }}
          readOnly={disabled}
          fontSize={14}
          showPrintMargin
          showGutter
          highlightActiveLine
          value={form.getFieldValue('formula')}
          setOptions={{
            tabSize: 4,
            enableSnippets: true,
            showLineNumbers: true,
            enableLiveAutocompletion: true,
            enableBasicAutocompletion: true,
          }}
          onLoad={onLoad}
        />
      </Form.Item>
      <Modal
        title={(

          <FormSubmitControls
            label="Instrucciones"
            onCancel={() => setVisible(false)}
          />
        )}
        visible={visible}
        footer={null}
        closable={false}
      >
        <Text>
          Estructura del script
        </Text>
        <br />
        <AceEditor
          style={{
            width: '100%',
            height: 160,
          }}
          value={values[valuesKey]}
          placeholder=""
          mode="python"
          theme="github"
          name="editor-disabled"
          fontSize={14}
          showPrintMargin
          showGutter
          setOptions={{
            tabSize: 4,
            showLineNumbers: true,
          }}
        />
      </Modal>
    </Col>
  );
};

Editor.propTypes = {
  form: PropTypes.shape().isRequired,
  formItemName: PropTypes.string,
  formItemLabel: PropTypes.string,
  rules: PropTypes.arrayOf(PropTypes.shape({})),
  descuento: PropTypes.bool,
  actualizacion: PropTypes.bool,
  recargo: PropTypes.bool,
  cargo: PropTypes.bool,
  variables: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
};

Editor.defaultProps = {
  formItemName: 'formula',
  formItemLabel: 'Fórmula',
  rules: [],
  descuento: false,
  actualizacion: false,
  recargo: false,
  cargo: false,
  variables: [],
  disabled: false,
};

export default Editor;
